<template>
  <v-form :lazy-validation="true" @submit.prevent="handleSubmit" v-model="valid" ref="form">
    <v-card>
      <v-toolbar color="primary" dark flat>
        <v-toolbar-title>{{ $t("common.create") }}</v-toolbar-title>
        <div class="flex-grow-1"></div>
      </v-toolbar>

      <v-card-text>
        <v-autocomplete
          :label="$t('tag.fields.applicationId')"
          :items="companyApps"
          item-text="name"
          item-value="applicationId"
          :loading="appsLoad"
          v-model="applicationId"
          :rules="applicationIdRule"
          prepend-icon="apps"
          autocomplete="off"
        ></v-autocomplete>
      </v-card-text>

      <v-card-text>
        <v-text-field
          :label="$t('tag.fields.deveui')"
          name="deveui"
          prepend-icon="domain"
          type="text"
          v-model="deveui"
          :rules="deveuiRules"
          :error-messages="deveuiError"
        ></v-text-field>
      </v-card-text>

      <v-card-text>
        <v-text-field
          :label="$t('tag.fields.appKey')"
          name="appKey"
          prepend-icon="domain"
          type="text"
          v-model="appKey"
          :rules="appKeyRules"
        ></v-text-field>
      </v-card-text>

      <v-card-text>
        <v-text-field
          :label="$t('tag.fields.appEui')"
          name="appEui"
          prepend-icon="domain"
          type="text"
          v-model="appEui"
        ></v-text-field>
      </v-card-text>

      <v-card-text>
        <v-text-field
          :label="$t('tag.fields.name')"
          name="name"
          prepend-icon="domain"
          type="text"
          v-model="name"
          :rules="nameRules"
        ></v-text-field>
      </v-card-text>

      <v-card-text>
        <v-text-field
          :label="$t('tag.fields.lat')"
          name="lat"
          prepend-icon="domain"
          type="text"
          v-model="latitude"
        ></v-text-field>
      </v-card-text>

      <v-card-text>
        <v-text-field
          :label="$t('tag.fields.long')"
          name="long"
          prepend-icon="domain"
          type="text"
          v-model="longitude"
        ></v-text-field>
      </v-card-text>

      <v-card-text>
        <DecoderSelect v-on:update-value="updateDecoder" :decoder="decoder" />
      </v-card-text>

      <v-card-actions>
        <v-btn color="primary" type="submit" x-large>{{ $t("common.create") }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import { mapActions, mapState } from "vuex";
import DecoderSelect from "@/components/tag/DecoderSelect.vue";
import i18n from "@/plugins/i18n";

export default {
  name: "TagCreate",
  components: {
    DecoderSelect,
  },

  data() {
    return {
      submitted: false,
      valid: false,
      deveui: "",
      appKey: "",
      appEui: "",
      name: "",
      latitude: "",
      longitude: "",
      applicationId: "",
      decoder: "",
      deveuiError: "",
      nameRules: [
        (v) =>
          !!v || this.$t("validation.required", [this.$t("tag.fields.name")]),
        (v) =>
          (v && v.length <= 255) ||
          this.$t("validation.max", [this.$t("tag.fields.name"), 255]),
      ],
      deveuiRules: [
        (v) =>
          !!v || this.$t("validation.required", [this.$t("tag.fields.deveui")]),
        (v) =>
          (v && v.length <= 255) ||
          this.$t("validation.max", [this.$t("tag.fields.deveui"), 255]),
      ],
      appKeyRules: [
        (v) =>
          v.length <= 255 ||
          this.$t("validation.max", [this.$t("tag.fields.appKey"), 255]),
      ],
      applicationIdRule: [
        (v) =>
          !!v ||
          this.$t("validation.required", [this.$t("tag.fields.applicationId")]),
      ],
    };
  },
  computed: {
    ...mapState("users", [
      "status",
      "currentUser",
      "userCompany",
      "hasCompany",
    ]),

    ...mapState("companies", {
      companyApps: "companyApps",
      appsLoad: "status.loading",
    }),

    ...mapState("tag", ["apiErrors"])
  },
  methods: {
    ...mapActions("tag", ["createTag"]),
    ...mapActions("companies", ["getCompanyApplications"]),

    updateDecoder(val) {
      this.decoder = val;
    },

    parseErrors() {
      // Clear old validation errors
      this.deveuiError = "";
      // Check for new validation errors, apiErrors have capitalized keys
      for (let error in this.apiErrors) {
        if (error === "Deveui") {
          this.deveuiError = i18n.t("validation.deveuiConflict");
        }
      }
    },

    handleSubmit() {
      if (!this.$refs.form.validate()) {
        this.valid = false;
        return;
      }

      this.submitted = true;
      this.latitude = this.latitude.replace(",", ".");
      this.longitude = this.longitude.replace(",", ".");

      const {
        deveui,
        name,
        profile,
        latitude,
        longitude,
        appKey,
        appEui,
        applicationId,
        decoder,
      } = this;

      if (name)
        this.createTag({
          applicationId: applicationId,
          payload: {
            deveui,
            name,
            profile,
            latitude,
            longitude,
            appKey,
            appEui,
            decoder,
          },
        }).then(() => {
          if (this.apiErrors.length == 0) {
            this.$router.push("/tag");
          }
          else
            this.parseErrors();
        });
    },
  },
  created() {
    if (!this.hasCompany) this.$router.push("/company/create");
    if (this.$route.params.deveui) this.deveui = this.$route.params.deveui;
    this.getCompanyApplications();
  },
};
</script>

<style></style>
